import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class QueryData<T = any> {

  constructor(private _api: FsApi) { }

  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `queries/${id}`,
      query,
      {
        key: 'query',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'queries',
      query,
      {
        key: 'queries',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `queries/${data.id}`,
      data,
      {
        key: 'query',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'queries',
      data,
      {
        key: 'query',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `queries/${data.id}`,
      data,
      {
        key: 'query',
        ...config,
      },
    );
  }

  public order(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'queries/order',
      data,
      {
        key: 'queries',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
